var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back"},[_c('span',{staticClass:"title"},[_vm._v("个人中心")]),_c('Button',{staticClass:"btn",on:{"click":function($event){return _vm.$router.push(`/cloud`)}}},[_c('Icon',{attrs:{"type":"ios-arrow-back"}}),_c('span',[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }